import { lazy } from "react";

export const CareerAdviceArticleContent = lazy(() => import("./CareerAdviceArticleContent"));
